module.exports = __webpack_public_path__ + "img/bf-am-banner2022.fdb83f94.png";